import { NavLink } from 'react-router-dom'
import { createStore } from '../store/state'

export default function LoginNav() {
    const { user } = createStore((state) => state)

    return (
        <>
            <li><NavLink to="/dashboard">Dashboard</NavLink></li>
            <li><NavLink to="/dashboard/order-list">Bookings</NavLink></li>
            <li><NavLink to="/dashboard/orders">Orders</NavLink></li>
            {user?.isAdmin && <li><NavLink to="/dashboard/products">Product</NavLink></li>}
            {user?.isAdmin && <li><NavLink to="/dashboard/category">Category</NavLink></li>}
            {user?.isAdmin && <li><NavLink to="/dashboard/coupon">Coupon</NavLink></li>}
        </>
    )
}
